import { useAuth } from "contexts/AuthContext";
import ProfilePictureManager from "./ProfilePictureManager";

export default function ProfileCard() {
    const { user } = useAuth();

    return (
        <div className="col-md-4 min-w-0">
            <div className="sb-panel mb-4">
                <div className="p-4 text-center">
                    <ProfilePictureManager />
                    <h5 className="card-title">{user?.firstName} {user?.lastName}</h5>
                    <p className="text-muted">{user?.email}</p>
                </div>
            </div>
        </div>
    );
}
